import axios from 'axios';
import authHeader from '../auth-header';

import tokenHeader from '../token-header';

// const API_URL = 'https://localhost:9090/api/all/';
import baseUrl from '../base-url';

const API_URL = baseUrl() + "/api/all/";

const getDataIuran = 'iuran-peserta';
const postDataIuran = 'iuran-peserta';
const deleteDataIuran = 'iuran-peserta';
const generateAnnualInvoice = 'generate-annual-invoice';

// const postDataKeanggotaanUrl = 'data-keanggotaan';
// const putDataKeanggotaan = 'data-keanggotaan/';
// const deleteDataKeanggotaan = 'data-keanggotaan/';

class IuranAnggotaService {
    getDataIuran(pageNo, pageSize, filter, status_pembayaran, periode, kategori) {
        return axios.get(API_URL + getDataIuran, {
            params: {
                pageNo,
                pageSize,
                filter,
                status_pembayaran,
                periode,
                kategori
            },
            headers: authHeader()
        });        
    }

    postDataIuran(formData) {
        return axios.post(
            API_URL + postDataIuran,
            formData,
            {
                headers: authHeader()
            }
        );
    }

    putDataIuran(id_invoice, id_iuran, id_payment, formData) {
        return axios.put(
            API_URL + postDataIuran + '?id_invoice=' + id_invoice + '&id_iuran_peserta=' + id_iuran + '&id_payment=' + id_payment,
            formData,
            {
                headers: authHeader()
            }
        );
    }

    generateAnnualInvoice(formData) {
        return axios.post(
            API_URL + generateAnnualInvoice,
            formData,
            {
                headers: authHeader()
            }
        );
    }

    deleteIuran(idIuran)
    {
        return axios.delete(
            API_URL + deleteDataIuran + '?id_iuran_peserta=' + idIuran,
            {
                headers: authHeader()
            }
        );
    }


 

}

export default new IuranAnggotaService();